<template>
    <div class="abs" style="top: 0px; right: 0px;">
        <div class="contentMenu">
            <div v-for="ticket in getRelatedTicketsStrip" class="content-ticket">
                <img :src="getUrlImage(ticket)" class="img-ticket" width="70%" @mousedown="cloneTicketStrip($event.target, ticket);" />
                <!-- <p> -->
                <!-- {{getTranslate(ticket.terms.name)}} -->
                <!-- </p> -->
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { stateMixin } from "../mixins/state";
import Globals from "../../globals";

export default {
    mixins: [stateMixin],
    data() {
        return {};
    },
    computed: {
        ...mapGetters("items", {
            getRelatedTicketsStrip: "getRelatedTicketsStrip"
        })
    },
    created() {
        let moduleEdit = this.getModulesEdit[0];
        this.findRelatedTicketsStrip(moduleEdit);
    },
    mounted() {},
    methods: {
        ...mapActions("items", {
            findRelatedTicketsStrip: "findRelatedTicketsStrip"
        }),
        cloneTicketStrip(elt, ticket) {
            this.setTicketStripToClone({ elt: elt, data: ticket });
        },
        getUrlImage(ticket) {
            let url = this.getPathImageComponent(ticket) ? Globals.getBaseUrl() + this.getPathImageComponent(ticket) : "";
            return url;
        }
    }
};
</script>

<style scoped lang="scss">
.contentMenu {
    z-index: 1;
    background: #fff;
    height: calc(100vh - 105px);
    .content-ticket {
        text-align: center;
        padding: 5px;
    }
    .img-ticket {
        /*padding: 10px;*/
    }
}
</style>



// WEBPACK FOOTER //
// TicketStrip.vue?466a1e4c